import React, { useEffect, useState } from 'react';
import styled from "styled-components";
import { useLocation, useNavigate } from 'react-router-dom';
import { Divider } from '@react-md/divider';

import logo from '../assets/logo_fonts.png'
import AppStateContext from '../appState/AppStateContext';
import ControlTrad from '../assets/trad/ControlTrad';
import {
    ActionIcon, SegmentedControl, TextInput, useComputedColorScheme, useMantineColorScheme, NavLink,
    Select, Drawer, Burger, Text, Space, Flex,
    Tooltip, Card, Title, Grid, Image, Button,
    Badge
} from '@mantine/core';

import { IconMoon, IconSun } from '@tabler/icons-react';
import LocalStorage from '../appState/LocalStorage';
import { useDisclosure } from '@mantine/hooks';
import HeaderFiltersDrawer from './HeaderFiltersDrawer';
import User from '../utils/User';

import gota1 from '../assets/gota_1B.webp';
import gota2 from '../assets/gota_2.webp';
import gota5 from '../assets/gota_3.webp';
import gota4 from '../assets/gota_4.webp';
import accesible from '../assets/accesbilitat.webp';
import qsocial from '../assets/Grup_Qualitat_Sabor_Aigua.webp'
import logoOAT from '../assets/logoOAT.png'
import AjTerrrassa from '../assets/logotip_ajuntament.webp'
import logoNic from '../assets/logoCoper.png'
import logoApp from '../assets/logo_fonts.png'
import VersionList from '../module/VersionList';

const Head = styled.div`
${props => ` 
    height: ${props.height < 450 ? "15vh" : '10vh'};
    background-color: ${!props.dark ? "#242424" : "#fff"};
  `}
  z-index: 2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
`;

const HeadMain = styled.div`
  display: flex;
  align-items: center;
    @media (max-width: 800px) {
    flex: 1;
  }
`;

const SearchMain = styled.div`
  margin-top: 17px;
  @media (max-width: 800px) {
    width: 100%;
  }
`;

const Search = styled.div`
  padding: 10px 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
  width:100%

`;

const ImgLogo = styled.img`
  width: 5rem;
  height: 5rem;
  cursor: pointer;
  @media (max-width: 800px) {
    width: 4rem;
    height: 4rem;
  }

`;



const ResultsList = styled.div`
  ${props => `
    background-color: ${!props.dark ? "#242424" : "#fff"};
    display: flex;
    flex-direction: column;
    box-shadow: 0px 0px 8px #ddd;
    border-radius: 10px;
    min-width: 300px;
    max-width: 300px;
    max-height: 300px;
    overflow-y: scroll;
    position: absolute;
    z-index: 2;
    @media (max-width: 800px) {
      min-width: 100vw;
      max-width: 100vw;
      left:0;
      border-radius: 0px;

    }
  `}
`;

const Result = styled.div`
  ${props => `
    &:hover {
      background: ${!props.dark ? "#555" : "#e6e6e6"};
    }
  `}
  display: flex;
  height: max-content;
  max-width: 300px;
  align-items: center;
  cursor: pointer;
  padding: 0 10px;
  @media (max-width: 800px) {
      max-width: 100%;
   }

`;


const MainFilter = styled.div`
    ${props => `
        display: flex;
        flex-direction: ${props.horizontal ? "row" : "column"};
        margin: 0 20px;
        align-items: ${props.horizontal ? "center" : ""};
    `}
`;

const HiddenResponsive = styled.div`
  cursor:pointer;
  margin: 0 20px;
  @media (max-width: 800px) {
   display:none;
}
`;


const Header = (props) => {
    const [text, setText] = useState("");
    const [result, setResult] = useState([]);
    const [openedHam, { toggle }] = useDisclosure();
    const [openedLeyenda, { toggle: toggleLey }] = useDisclosure();
    const [openedAboutBy, { toggle: toggleBy }] = useDisclosure();
    const [opened, { open, close }] = useDisclosure(false);
    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);

    const navigate = useNavigate();
    const location = useLocation();
    const { setColorScheme } = useMantineColorScheme();
    const computedColorScheme = useComputedColorScheme('light', { getInitialValueInEffect: true });
    const appState = React.useContext(AppStateContext);
    const fontsState = appState.state.get("getAllFonts");



    const handleResize = () => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight)
    };

    const goToNavegate = (id) => {
        if (id === null) {
            navigate("/")
        } else {
            navigate("/font/" + id)
            setText("");
            setResult([]);
            document.getElementById("buscador").value = "";
        }
    }

    const renderResults = () => {
        let views = [];
        if (text.length > 3) {
            result.forEach(element => {
                views.push(
                    <>
                        <Result dark={computedColorScheme === 'light'} onClick={() => { goToNavegate(element.id) }}>
                            <div style={{ maxWidth: "400px", overflow: "hidden", textOverflow: "ellipsis" }}>{element.address?.toUpperCase()}</div>
                        </Result>
                        <Divider style={{ width: "100%" }} />
                    </>
                )
            });
        } else {
            if (text.length !== 0) { views.push(ControlTrad.getTrad("write3char")); }
        }
        return views;
    }

    useEffect(() => {
        renderResults();
    }, [result])

    useEffect(() => {
        let array = [];
        const upperText = text.toUpperCase();
        if (upperText.length > 3) {
            array = fontsState.filter(item =>
                item.id.toUpperCase().includes(upperText) ||
                item.address.toUpperCase().includes(upperText)
            );
            setResult(array);
        }
    }, [text])

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        
    }, []);

    /*
                                {!admin ?
                                <div style={{ width: '100%' }} onClick={() => { navigate("/login") }}>
                                    <NavLink label={ControlTrad.getTrad("administracio")} />
                                </div>
                                :
                                <div style={{ width: '100%' }} onClick={() => { let f = new Firebase(); f.auth.signOut(); window.location.reload(); }}>
                                    <NavLink label={ControlTrad.getTrad("tancarSesio")} />
                                </div>
                            }
    */
    return (
        <Head dark={computedColorScheme === 'light'} height={height}>
            <HeadMain>
                <Burger opened={openedHam} onClick={(e) => { toggle(e); open(e) }} aria-label="Toggle navigation" />
                <ImgLogo src={logo} onClick={() => { goToNavegate(null) }} />
                {props?.searchMap ?
                    <div style={{ width: width > 800 ? "20vw" : "100%" }}>
                        <Search>
                            <TextInput
                                w={width > 800 ? "20vw" : "100%"}
                                id={'buscador'}
                                placeholder={ControlTrad.getTrad("search")}
                                onInput={e => setText(e.target.value)}
                            />
                        </Search>
                        <SearchMain style={{ marginTop: "17px" }}>
                            <ResultsList dark={computedColorScheme === 'light'}>
                                {renderResults()}
                            </ResultsList>
                        </SearchMain>

                    </div>

                    :

                    width >= 800 ?
                        <div>
                            <HeadMain>
                                <TextInput
                                    id={'buscador'}
                                    value={props?.searchTerm}
                                    placeholder={ControlTrad.getTrad("search")}
                                    onInput={(e) => props?.setSearchTerm(e.target.value)}
                                    label={ControlTrad.getTrad("search")}
                                />
                                <MainFilter horizontal={false}>
                                    <Select
                                        onChange={(e) => props?.setFilterType(e)}
                                        defaultValue={''}
                                        value={props?.filterType}
                                        data={[{ value: '', label: ControlTrad.getTrad("fontsAll") }, { value: "1", label: ControlTrad.getTrad("fontBeure") },
                                        { value: "2", label: ControlTrad.getTrad("fontBeureSing") }, { value: "3", label: ControlTrad.getTrad("fontGossos") },
                                        { value: "4", label:ControlTrad.getTrad("fontAccesible")},
                                        ]}
                                        allowDeselect={false}
                                        label={ControlTrad.getTrad("typeFont")}

                                    />
                                </MainFilter>
                                <TextInput
                                    type="number"
                                    id={'buscador'}
                                    value={props?.maxDistance}
                                    placeholder={ControlTrad.getTrad("distance")}
                                    onInput={(e) => props?.setMaxDistance(e.target.value)}
                                    label={ControlTrad.getTrad("distance")}
                                />
                            </HeadMain>
                        </div>
                        :
                        <>
                            <HeaderFiltersDrawer
                                searchTerm={props.searchTerm}
                                setSearchTerm={props.setSearchTerm}
                                filterType={props.filterType}
                                setFilterType={props.setFilterType}
                                maxDistance={props.maxDistance}
                                setMaxDistance={props.setMaxDistance}
                            />
                        </>

                }
                {props?.searchMap ?
                    <HiddenResponsive>
                        <Text onClick={() => { navigate("/list") }}>{ControlTrad.getTrad("font")}</Text>
                    </HiddenResponsive>
                    : <></>}

            </HeadMain>

            <Drawer offset={8} radius="md" opened={opened} onClose={(e) => { close(e); toggle(e); }} title={ControlTrad.getTrad("menu")}>
                <div style={{ display: "flex", flexDirection: "column", height: "89vh" }}>
                    <Flex
                        justify="space-between"
                        align="flex-start"
                        direction="column"
                        wrap="nowrap"
                        style={{ height: "100%" }}
                    >
                        <div style={{ flex: 1, width: '100%' }}>
                            <div style={{ width: '100%' }} onClick={() => { navigate("/") }}>
                                <NavLink active={location.pathname === "/"} label={ControlTrad.getTrad("mapa")} />
                            </div>
                            <div style={{ width: '100%' }} onClick={() => { navigate("/list") }}>
                                <Tooltip position="top-start"
                                    withArrow arrowPosition="side" arrowOffset={5} arrowSize={7} arrowRadius={5}
                                    label={ControlTrad.getTrad("veurefonts")}>
                                    <NavLink active={location.pathname === "/list"} label={ControlTrad.getTrad("font")} />
                                </Tooltip>
                            </div>
                            <div style={{ width: '100%' }} onClick={(e) => { close(e); toggle(e); toggleLey(e) }}>
                                <NavLink label={ControlTrad.getTrad("lleyenda")} />
                            </div>

                        </div>
                    </Flex>
                    <Flex>
                        <div style={{ flex: 1, width: '100%' }}>
                            <div style={{ width: '100%' }} onClick={(e) => { close(e); toggle(e); toggleBy(e) }}>
                                <NavLink label={ControlTrad.getTrad("AcercaBy")} />
                            </div>

                            <Space h="md" />
                            <Divider />
                            <Space h="md" />
                            <div style={{ display: "flex", justifyContent: 'space-between', alignItems: "center" }}>
                                <Tooltip label={ControlTrad.getTrad("idiomaSelect")}>
                                    <SegmentedControl
                                        value={props.lang}
                                        onChange={(e) => {
                                            LocalStorage.set("LANG", e);
                                            props.setLang(e);
                                            User.setLang(e);
                                        }}
                                        data={[
                                            { label: 'CAT', value: 'CAT' },
                                            { label: 'ESP', value: 'ESP' },
                                        ]}
                                    />
                                </Tooltip>

                                <Tooltip label={computedColorScheme === "dark" ? ControlTrad.getTrad("modeLight") : ControlTrad.getTrad("modeDark")}>
                                    <ActionIcon
                                        onClick={() => setColorScheme(computedColorScheme === 'light' ? 'dark' : 'light')}
                                        variant="default"
                                        size="lg"
                                        aria-label="Toggle color scheme"
                                    >
                                        {computedColorScheme === 'light' ? <IconSun stroke={1.5} /> : <IconMoon stroke={1.5} />}
                                    </ActionIcon>
                                </Tooltip>
                            </div>
                            <Space h="md" />
                            <Divider />
                        </div>
                    </Flex>
                </div>
            </Drawer>


            <Drawer size={"100%"} offset={8} radius="md" opened={openedLeyenda} onClose={(e) => { toggleLey(e); open(e); toggle(e); }} title={ControlTrad.getTrad("lleyenda")}>
                <Card shadow="sm" padding="lg" radius="md" withBorder>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img alt={""} src={gota1} />
                        <Title order={2}>
                            {ControlTrad.getTrad("fontBeure")}
                        </Title>
                    </div>
                    <br />
                    {ControlTrad.getTrad("explicacio1")}
                </Card>
                <br />
                <Card shadow="sm" padding="lg" radius="md" withBorder>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Image style={{width:'1.75rem'}} src={accesible} alt="Icono discapacitat" />
                        <img alt={""} src={gota4} />
                        <Title order={2}>
                            {ControlTrad.getTrad("fontAccesible")}
                        </Title>
                    </div>
                    <br />
                    {ControlTrad.getTrad("explicacio3")}
                </Card>
                <br />
                <Card shadow="sm" padding="lg" radius="md" withBorder>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img alt={""} src={gota2} />
                        <Title order={2}>
                            {ControlTrad.getTrad("fontBeureSing")}
                        </Title>
                    </div>
                    <br />
                    {ControlTrad.getTrad("explicacio2")}
                </Card>
                <br />
                <Card shadow="sm" padding="lg" radius="md" withBorder>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img alt={""} src={gota5} />
                        <Title order={2}>
                            {ControlTrad.getTrad("fontGossos")}
                        </Title>
                    </div>
                    <br />
                    {ControlTrad.getTrad("explicacio5")}
                </Card>

            </Drawer>
            <Drawer size={"100%"} offset={8} radius="md" opened={openedAboutBy} onClose={(e) => { toggleBy(e); open(e); toggle(e); }} title={ControlTrad.getTrad("AcercaBy")}>
                <Flex
                    gap="md"
                    justify="flex-start"
                    align="center"
                    direction="row"
                    wrap="wrap"
                >
                    <Image src={logoApp} h={'100px'} w={'100px'} />
                    <Title >{ControlTrad.getTrad("appname")} - {ControlTrad.getTrad("version")}  {process.env.REACT_APP_VERSION} </Title>
                    <Badge color="blue">BETA</Badge>
                </Flex>



                <Space h='md' />
                <Divider />
                <Title>{ControlTrad.getTrad("entityOrg")}:</Title>
                <Space h='md' />
                <Grid gutter="xl" grow>
                    <Grid.Col span={2}>
                        <Card h={'300px'} style={{ cursor: 'pointer', color: 'black' }} bg={"white"} shadow="sm" radius="md" withBorder
                            onClick={() => { window.open("https://oat.cat", '_black').focus(); }}
                        >
                            <Flex h="100%" align="center" justify="center" direction={"column"}>
                                <Flex h="100%" align="center" justify="center" direction={"row"}>
                                    <Image src={logoOAT} h='85px' w='300px' />
                                </Flex>
                            </Flex>

                        </Card>
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <Card h={'300px'} style={{ cursor: 'pointer', color: 'black' }} bg={"white"} shadow="sm" radius="md" withBorder
                            onClick={() => { window.open("https://www.oat.cat/grups-de-treball/qualitat/", '_black').focus(); }}
                        >
                            <Flex h="100%" align="center" justify="center" direction={"column"}>
                                <Flex h="100%" align="center" justify="center" direction={"row"}>
                                    <Image src={qsocial} h='105px' w='300px' />
                                </Flex>
                                <Text style={{ margin: "10px 0 0 0" }}>Grup Qualitat i Sabor de l'Aigua (OAT)</Text>
                                <Divider style={{width:"100%"}} />
                                <Text style={{ margin: "10px 0 0 0" }}>Juana Martín Hernández</Text>
                                <Text style={{ margin: "10px 0 0 0" }}>Pilar Quintanilla Solera</Text>
                                <Text style={{ margin: "10px 0 0 0" }}>Beatriz Escribano Rodríguez de Robles</Text>
                            </Flex>
                        </Card>
                    </Grid.Col>
                </Grid>

                <Space h='md' />
                <Divider />
                <Space h='md' />
                <Title>{ControlTrad.getTrad("dev")}:</Title>
                <Space h='md' />
                <Grid gutter="xl" grow>
                    <Grid.Col span={4}>
                        <Card shadow="sm" style={{ color: 'black' }} bg={"white"} padding="lg" radius="md" withBorder>
                            <Title order={2}>{ControlTrad.getTrad("collaborators")}</Title>
                            <Space h="xs" />
                            <Title order={3}>Eric Luján Prieto</Title>
                            <Button color="blue" fullWidth mt="md" radius="md" onClick={() => { window.open("https://sites.google.com/view/sackmike093/", '_black').focus(); }}>
                                {ControlTrad.getTrad("viewPortafoli")}
                            </Button>
                        </Card>
                    </Grid.Col>
                    <Grid.Col span={4}>
                        <Card shadow="sm" style={{ color: 'black' }} bg={"white"} padding="lg" radius="md" withBorder>
                            <Title order={2}>{ControlTrad.getTrad("collaborators")}</Title>
                            <Space h="xs" />
                            <Title order={3}>Jose Ignacio Barragán López</Title>
                            <Button color="blue" fullWidth mt="md" radius="md"
                                onClick={() => { window.open("https://sites.google.com/view/natxo", '_black').focus(); }}
                            >
                                {ControlTrad.getTrad("viewPortafoli")}
                            </Button>
                        </Card>
                    </Grid.Col>

                </Grid>

                <Space h='md' />
                <Divider />
                <Space h='md' />
                <Title>{ControlTrad.getTrad("agredments")}:</Title>
                <Space h='md' />
                <Grid gutter="xl" grow>

                    <Grid.Col span={2}>
                        <Card h={'200px'} style={{ cursor: 'pointer', color: 'black' }} bg={"white"} shadow="sm" radius="md" withBorder
                            onClick={() => { window.open("https://www.terrassa.cat/es/espais-verds", '_black').focus(); }}
                        >
                            <Flex h="100%" align="center" justify="center" direction={"column"}>
                                <Image src={AjTerrrassa} h='105px' w='300px' />
                                <Text style={{ margin: "10px 0 0 0" }}>Espais Verds i Biodiversitat Urbana</Text>
                            </Flex>
                        </Card>
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <Card h={'200px'} style={{ cursor: 'pointer', color: 'black' }} bg={"white"} shadow="sm" radius="md" withBorder
                            onClick={() => { window.open("https://copernic.cat/ca", '_black').focus(); }}
                        >
                            <Flex h="100%" align="center" justify="center" direction={"column"}>
                                <Image src={logoNic} h='100px' w='120px' />
                                <Text style={{ margin: "10px 0 0 0" }}> (CFGS) Desenvolupament d'aplicacions multiplataforma</Text>
                            </Flex>
                        </Card>
                    </Grid.Col>
                </Grid>
                <Space h='md' />
                <Divider />
                <p style={{fontSize:"12px"}}>
                    <a property="dct:title" rel="cc:attributionURL" href="https://creativecommons.org/licenses/by-nc-sa/4.0/?ref=chooser-v1">
                        <img style={{ height: "20px", marginLeft: "3px", verticalAlign: "text-bottom" }} src="https://mirrors.creativecommons.org/presskit/icons/cc.svg?ref=chooser-v1" alt="" />
                        <img style={{ height: "20px", marginLeft: "3px", verticalAlign: "text-bottom" }} src="https://mirrors.creativecommons.org/presskit/icons/by.svg?ref=chooser-v1" alt="" />
                        <img style={{ height: "20px", marginLeft: "3px", verticalAlign: "text-bottom" }} src="https://mirrors.creativecommons.org/presskit/icons/nc.svg?ref=chooser-v1" alt="" />
                        <img style={{ height: "20px", marginLeft: "3px", verticalAlign: "text-bottom" }} src="https://mirrors.creativecommons.org/presskit/icons/sa.svg?ref=chooser-v1" alt="" />
                        
                        Fonts de Terrassa</a> ({new Date().getFullYear()}) by <a rel="cc:attributionURL dct:creator" property="cc:attributionName" href="https://www.oat.cat/">Observatori d'aigues de Terrassa</a> is licensed under <a href="https://creativecommons.org/licenses/by-nc-sa/4.0/?ref=chooser-v1" target="_blank" rel="license noopener noreferrer" style={{ display: "inline-block" }}> CC BY-NC-SA 4.0
                    </a>
                </p>
                <Divider />

                <Space h='md' />
                <Title order={3}>{ControlTrad.getTrad("controlversion")}:</Title>
                <Space h='md' />
                <VersionList />
                <Space h='md' />

            </Drawer>
        </Head>
    );
};

export default Header;
